import { UniversalCheckoutForm } from '@/features/payments/components/UniversalCheckoutForm'
import { PlanDuration, PlanType } from '@/features/plans/types/plan.types'

interface CheckoutFormProps {
  data: {
    branch: {
      id: number
      name: string
      address?: string
      city?: string
      country?: string
    }
    plan: {
      id: number
      branch_id?: number | null
      name: string
      description?: string
      price: number
      currency: string
      duration_value?: number | null
      duration_unit?: PlanDuration
      plan_type: PlanType
      is_active: boolean
      is_global: boolean
      created_at: string
      updated_at: string
    }
    account_data: {
      first_name: string
      last_name: string
      email: string
      phone: string
      civil_id: string
      country: string
      city?: string
    }
  }
  sessionId: string | null
  onSuccess?: () => void
}

/**
 * Registration checkout form wrapper
 * Uses UniversalCheckoutForm in 'registration' mode
 */
export function CheckoutForm({ data, sessionId, onSuccess }: CheckoutFormProps) {
  const { branch, plan, account_data } = data

  return (
    <UniversalCheckoutForm
      branch={branch}
      plan={plan}
      accountData={account_data}
      mode='registration'
      sessionId={sessionId}
      onSuccess={onSuccess}
    />
  )
}
